/** Registry key for the VhResource entity. */
export const VH_RESOURCE = 'VhResource';
//# sourceMappingURL=resourceData.js.map